<div class="property-listing-container bg-gradient-to-br from-gray-50 via-blue-50 to-gray-50 min-h-screen">
  <!-- Hero Section -->
  <section class="relative bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-16 overflow-hidden">
    <!-- Decorative Background Elements -->
    <div class="absolute inset-0 opacity-10">
      <div class="absolute top-0 left-0 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
      <div class="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full filter blur-3xl transform translate-x-1/2 translate-y-1/2"></div>
    </div>
    
    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-6">
          <div class="hidden md:flex items-center justify-center w-16 h-16 bg-white bg-opacity-20 backdrop-blur-sm rounded-2xl">
            <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-3m0 0l7-4 7 4M5 9v10a1 1 0 001 1h12a1 1 0 001-1V9m-9 4l4 2m-2-2l-4-2"></path>
            </svg>
          </div>
          <div>
            <h1 class="text-4xl sm:text-5xl font-bold mb-2 tracking-tight">
              {{ isEditMode() ? 'Edit Property Listing' : 'Create New Property' }}
            </h1>
            <p class="text-lg text-blue-100" *ngIf="!isEditMode()">Add a new property to your listings</p>
            <p class="text-lg text-blue-100" *ngIf="isEditMode()">Update your property details</p>
          </div>
        </div>
        <button
          type="button"
          (click)="goBack()"
          [disabled]="loading()"
          class="bg-white bg-opacity-20 backdrop-blur-sm hover:bg-opacity-30 text-white px-6 py-3 rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 border border-white border-opacity-20 hover:scale-105">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
          </svg>
          Back
        </button>
      </div>
    </div>
  </section>

  <div class="max-w-5xl mx-auto py-12 px-4 sm:px-6 lg:px-8 -mt-8 relative z-10">
    <!-- Progress indicator -->
    <div class="mb-8 bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6">
      <div class="flex items-center justify-between gap-2 sm:gap-0">
        <div class="flex flex-col sm:flex-row items-center gap-1 sm:gap-2">
          <div class="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold text-sm">1</div>
          <span class="font-medium text-gray-900 text-xs sm:text-sm text-center">Basic Info</span>
        </div>
        <div class="hidden md:block h-px flex-1 bg-gray-200 mx-2"></div>
        <div class="flex flex-col sm:flex-row items-center gap-1 sm:gap-2">
          <div class="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold text-sm">2</div>
          <span class="font-medium text-gray-900 text-xs sm:text-sm text-center">Location</span>
        </div>
        <div class="hidden md:block h-px flex-1 bg-gray-200 mx-2"></div>
        <div class="flex flex-col sm:flex-row items-center gap-1 sm:gap-2">
          <div class="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold text-sm">3</div>
          <span class="font-medium text-gray-900 text-xs sm:text-sm text-center">Details</span>
        </div>
        <div class="hidden md:block h-px flex-1 bg-gray-200 mx-2"></div>
        <div class="flex flex-col sm:flex-row items-center gap-1 sm:gap-2">
          <div class="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold text-sm">4</div>
          <span class="font-medium text-gray-900 text-xs sm:text-sm text-center">Media</span>
        </div>
      </div>
    </div>
    <!-- Skeleton Loading State -->
    <div *ngIf="loading()" class="animate-pulse space-y-8">
      <!-- Header Skeleton -->
      <div class="flex items-center justify-between mb-6">
        <div class="h-8 bg-gray-200 rounded w-64"></div>
        <div class="h-10 bg-gray-200 rounded w-24"></div>
      </div>

      <!-- Form Sections Skeleton -->
      <div class="border-b pb-6 space-y-4">
        <div class="h-6 bg-gray-200 rounded w-48"></div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-16"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-20"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-24"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-28"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Address Section Skeleton -->
      <div class="border-b pb-6 space-y-4">
        <div class="h-6 bg-gray-200 rounded w-32"></div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-16"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-20"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-16"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-20"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Details Section Skeleton -->
      <div class="border-b pb-6 space-y-4">
        <div class="h-6 bg-gray-200 rounded w-40"></div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-16"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-20"></div>
            <div class="h-10 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Images Section Skeleton -->
      <div class="space-y-4">
        <div class="h-6 bg-gray-200 rounded w-32"></div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div class="h-48 bg-gray-200 rounded"></div>
          <div class="h-48 bg-gray-200 rounded"></div>
          <div class="h-48 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>

    <!-- Actual Content (Hidden while loading) -->
    <div *ngIf="!loading()" class="space-y-6">
      <form class="space-y-6">
        <!-- Basic Information Section -->
        <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
          <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
            <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg">
              <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <div>
              <h3 class="text-xl font-bold text-gray-900">Basic Information</h3>
              <p class="text-sm text-gray-500 mt-1">Essential details about your property</p>
            </div>
          </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
            </svg>
            Title <span class="text-red-500">*</span>
          </label>
          <input
            type="text"
            [(ngModel)]="title"
            name="title"
            [disabled]="loading()"
            placeholder="e.g., Modern Achrafieh Apartment"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 placeholder-gray-400"
          />
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-3m0 0l7-4 7 4M5 9v10a1 1 0 001 1h12a1 1 0 001-1V9m-9 4l4 2m-2-2l-4-2"></path>
            </svg>
            Property Type <span class="text-red-500">*</span>
          </label>
          <select
            [(ngModel)]="propertyType"
            name="propertyType"
            [disabled]="loading()"
            required
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 bg-white"
          >
            <option value="Apartment">🏢 Apartment</option>
            <option value="Villa">🏡 Villa</option>
            <option value="Land">🌳 Land</option>
            <optgroup label="🏪 Commercial">
              <option value="Commercial - Office">📋 Office</option>
              <option value="Commercial - Warehouse">📦 Warehouse</option>
              <option value="Commercial - Shop">🛍️ Shop</option>
              <option value="Commercial - Industrial Land">🏭 Industrial Land</option>
              <option value="Commercial - Building">🏢 Building</option>
              <option value="Commercial - Showroom">🎪 Showroom</option>
            </optgroup>
          </select>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            Listing Type <span class="text-red-500">*</span>
          </label>
          <select
            [(ngModel)]="listingType"
            name="listingType"
            [disabled]="loading()"
            required
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 bg-white"
          >
            <option value="sale">💰 For Sale</option>
            <option value="rent">🔑 For Rent</option>
          </select>
        </div>

        <div class="md:col-span-2 group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
            Description <span class="text-red-500">*</span>
          </label>
          <app-rich-text-editor
            [(ngModel)]="description"
            name="description"
            [disabled]="loading()"
            placeholder="Write a detailed description of the property... Highlight key features, amenities, and what makes this property special."
            [showCharCount]="true"
          ></app-rich-text-editor>
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-3">Publication Status</label>
          <div class="bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl p-4 border border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-white flex items-center justify-center shadow-sm">
                  <svg class="w-5 h-5" [class.text-gray-400]="!isPublished()" [class.text-green-500]="isPublished()" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                  </svg>
                </div>
                <div>
                  <p class="text-sm font-medium text-gray-900">{{ isPublished() ? 'Published' : 'Draft' }}</p>
                  <p class="text-xs text-gray-500">{{ isPublished() ? 'Visible to public' : 'Hidden from public' }}</p>
                </div>
              </div>
              <button
                type="button"
                [disabled]="loading()"
                (click)="isPublished.set(!isPublished())"
                [class.bg-green-500]="isPublished()"
                [class.bg-gray-300]="!isPublished()"
                class="relative inline-flex h-7 w-14 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-inner"
              >
                <span
                  [class.translate-x-7]="isPublished()"
                  [class.translate-x-1]="!isPublished()"
                  class="inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 shadow-md mt-1"
                ></span>
              </button>
            </div>
          </div>
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-3">Homepage Feature</label>
          <div class="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-4 border border-blue-100">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-lg bg-white flex items-center justify-center shadow-sm">
                  <svg class="w-5 h-5" [class.text-gray-400]="!addToHomepage()" [class.text-blue-500]="addToHomepage()" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                  </svg>
                </div>
                <div>
                  <p class="text-sm font-medium text-gray-900">{{ addToHomepage() ? 'Featured' : 'Standard' }}</p>
                  <p class="text-xs text-gray-500">{{ addToHomepage() ? 'Show on homepage' : 'Not featured' }}</p>
                </div>
              </div>
              <button
                type="button"
                [disabled]="loading()"
                (click)="addToHomepage.set(!addToHomepage())"
                [class.bg-blue-500]="addToHomepage()"
                [class.bg-gray-300]="!addToHomepage()"
                class="relative inline-flex h-7 w-14 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-inner"
              >
                <span
                  [class.translate-x-7]="addToHomepage()"
                  [class.translate-x-1]="!addToHomepage()"
                  class="inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 shadow-md mt-1"
                ></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Location Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Location</h3>
          <p class="text-sm text-gray-500 mt-1">Where is your property located?</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="md:col-span-2 group" *ngIf="showAddressLine1()">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Address Line 1</label>
          <input
            type="text"
            [(ngModel)]="addressLine1"
            name="addressLine1"
            [disabled]="loading()"
            placeholder="Rue Abdel Wahab El Inglizi"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 placeholder-gray-400"
          />
        </div>

        <div class="md:col-span-2 group" *ngIf="showAddressLine2()">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Address Line 2</label>
          <input
            type="text"
            [(ngModel)]="addressLine2"
            name="addressLine2"
            [disabled]="loading()"
            placeholder="Building name, floor, etc. (optional)"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 placeholder-gray-400"
          />
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">City <span class="text-red-500">*</span></label>
          <input
            type="text"
            [(ngModel)]="city"
            name="city"
            [disabled]="loading()"
            placeholder="Beirut"
            required
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 placeholder-gray-400"
          />
        </div>

        <div class="group" *ngIf="showState()">
          <label class="block text-sm font-semibold text-gray-700 mb-2">State/Province</label>
          <input
            type="text"
            [(ngModel)]="state"
            name="state"
            [disabled]="loading()"
            placeholder="Mount Lebanon"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 placeholder-gray-400"
          />
        </div>

        <div class="group" *ngIf="showPostalCode()">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Postal Code</label>
          <input
            type="text"
            [(ngModel)]="postalCode"
            name="postalCode"
            [disabled]="loading()"
            placeholder="1107 2810"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 placeholder-gray-400"
          />
        </div>

        <div class="group" [class.md:col-span-2]="!showState() && !showPostalCode()">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Country <span class="text-red-500">*</span></label>
          <input
            type="text"
            [(ngModel)]="country"
            name="country"
            [disabled]="loading()"
            placeholder="Lebanon"
            required
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 placeholder-gray-400"
          />
        </div>

        <!-- Optional Fields Checkboxes -->
        <div class="md:col-span-2 mt-4 pt-6 border-t border-gray-200">
          <p class="text-sm font-semibold text-gray-700 mb-3">Optional Address Details</p>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="showAddressLine1"
                name="showAddressLine1"
                class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm text-gray-700 group-hover:text-gray-900">Address Line 1</span>
            </label>

            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="showAddressLine2"
                name="showAddressLine2"
                class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm text-gray-700 group-hover:text-gray-900">Address Line 2</span>
            </label>

            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="showState"
                name="showState"
                class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm text-gray-700 group-hover:text-gray-900">State/Province</span>
            </label>

            <label class="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                [(ngModel)]="showPostalCode"
                name="showPostalCode"
                class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
              />
              <span class="text-sm text-gray-700 group-hover:text-gray-900">Postal Code</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Property Details Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Property Details</h3>
          <p class="text-sm text-gray-500 mt-1">Specifications and features</p>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            🛏️ Bedrooms <span class="text-red-500">*</span>
          </label>
          <input
            type="number"
            [(ngModel)]="bedrooms"
            name="bedrooms"
            [disabled]="loading()"
            placeholder="0"
            min="0"
            required
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 text-center font-semibold"
          />
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            🚿 Bathrooms <span class="text-red-500">*</span>
          </label>
          <input
            type="number"
            [(ngModel)]="bathrooms"
            name="bathrooms"
            [disabled]="loading()"
            placeholder="0"
            min="0"
            required
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 text-center font-semibold"
          />
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            📐 Area (m²) <span class="text-red-500">*</span>
          </label>
          <input
            type="number"
            [(ngModel)]="area"
            name="area"
            [disabled]="loading()"
            placeholder="0"
            min="0"
            required
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 text-center font-semibold"
          />
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            🏢 Floor
          </label>
          <input
            type="number"
            [(ngModel)]="floor"
            name="floor"
            [disabled]="loading()"
            placeholder="0"
            min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 text-center font-semibold"
          />
        </div>
      </div>
    </div>

    <!-- Building Information Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Building Information</h3>
          <p class="text-sm text-gray-500 mt-1">Details about the building structure</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Year Built</label>
          <input type="number" [(ngModel)]="yearBuilt" name="yearBuilt" [disabled]="loading()" placeholder="e.g., 2015" min="1800" [max]="maxYear"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Building Standing</label>
          <input type="text" [(ngModel)]="buildingStanding" name="buildingStanding" [disabled]="loading()" placeholder="e.g., Corner building with sea view"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Building Floors</label>
          <input type="number" [(ngModel)]="buildingFloors" name="buildingFloors" [disabled]="loading()" placeholder="0" min="1"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Apartments Per Floor</label>
          <input type="number" [(ngModel)]="apartmentsPerFloor" name="apartmentsPerFloor" [disabled]="loading()" placeholder="0" min="1"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Neighborhood</label>
          <input type="text" [(ngModel)]="neighborhood" name="neighborhood" [disabled]="loading()" placeholder="e.g., Achrafieh, Verdun, Hamra"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Zone</label>
          <select [(ngModel)]="zone" name="zone" [disabled]="loading()"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300">
            <option value="">Select zone</option>
            <option value="residential">Residential</option>
            <option value="commercial">Commercial</option>
            <option value="mixed">Mixed Use</option>
            <option value="industrial">Industrial</option>
          </select>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-6 mt-6">
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="hasElevator" name="hasElevator" [disabled]="loading()" id="hasElevator"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="hasElevator" class="ml-2 block text-sm text-gray-700">Elevator</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="hasGenerator" name="hasGenerator" [disabled]="loading()" id="hasGenerator"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="hasGenerator" class="ml-2 block text-sm text-gray-700">Generator</label>
        </div>
      </div>
    </div>

    <!-- Area & Dimensions Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Area & Dimensions</h3>
          <p class="text-sm text-gray-500 mt-1">Detailed measurements</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Habitable Area (m²)</label>
          <input type="number" [(ngModel)]="habitableAreaM2" name="habitableAreaM2" [disabled]="loading()" placeholder="0" min="0" step="0.01"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Land Area (m²)</label>
          <input type="number" [(ngModel)]="landAreaM2" name="landAreaM2" [disabled]="loading()" placeholder="0" min="0" step="0.01"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Usable Area (m²)</label>
          <input type="number" [(ngModel)]="usableAreaM2" name="usableAreaM2" [disabled]="loading()" placeholder="0" min="0" step="0.01"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Total Area (m²)</label>
          <input type="number" [(ngModel)]="totalAreaM2" name="totalAreaM2" [disabled]="loading()" placeholder="0" min="0" step="0.01"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Ceiling Height (m)</label>
          <input type="number" [(ngModel)]="ceilingHeightM" name="ceilingHeightM" [disabled]="loading()" placeholder="0" min="0" step="0.01"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
      </div>
    </div>

    <!-- Room Configuration Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Room Configuration</h3>
          <p class="text-sm text-gray-500 mt-1">Detailed room breakdown</p>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Living Rooms</label>
          <input type="number" [(ngModel)]="livingRoom" name="livingRoom" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Living/Dining</label>
          <input type="number" [(ngModel)]="livingDining" name="livingDining" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Master Bedrooms</label>
          <input type="number" [(ngModel)]="masterBedrooms" name="masterBedrooms" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Guest Bathrooms</label>
          <input type="number" [(ngModel)]="guestBathrooms" name="guestBathrooms" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Maid Bathrooms</label>
          <input type="number" [(ngModel)]="maidBathrooms" name="maidBathrooms" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Maid Rooms</label>
          <input type="number" [(ngModel)]="maidRooms" name="maidRooms" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Office Rooms</label>
          <input type="number" [(ngModel)]="officeRooms" name="officeRooms" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
      </div>
    </div>

    <!-- Property Features Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Property Features</h3>
          <p class="text-sm text-gray-500 mt-1">Special characteristics</p>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="isDuplex" name="isDuplex" [disabled]="loading()" id="isDuplex"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="isDuplex" class="ml-2 block text-sm text-gray-700">Duplex</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="hasTerrace" name="hasTerrace" [disabled]="loading()" id="hasTerrace"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="hasTerrace" class="ml-2 block text-sm text-gray-700">Terrace</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="hasGarden" name="hasGarden" [disabled]="loading()" id="hasGarden"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="hasGarden" class="ml-2 block text-sm text-gray-700">Garden</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="hasView" name="hasView" [disabled]="loading()" id="hasView"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="hasView" class="ml-2 block text-sm text-gray-700">Has View</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="isAdvertised" name="isAdvertised" [disabled]="loading()" id="isAdvertised"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="isAdvertised" class="ml-2 block text-sm text-gray-700">Advertised</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="groundFloor" name="groundFloor" [disabled]="loading()" id="groundFloor"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="groundFloor" class="ml-2 block text-sm text-gray-700">Ground Floor</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="mezzanine" name="mezzanine" [disabled]="loading()" id="mezzanine"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="mezzanine" class="ml-2 block text-sm text-gray-700">Mezzanine</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="basement" name="basement" [disabled]="loading()" id="basement"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="basement" class="ml-2 block text-sm text-gray-700">Basement</label>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Google Maps URL</label>
          <input type="text" [(ngModel)]="googleMapUrl" name="googleMapUrl" [disabled]="loading()" placeholder="https://maps.google.com/..."
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
      </div>
    </div>

    <!-- Amenities & Equipment Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-500 to-cyan-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Amenities & Equipment</h3>
          <p class="text-sm text-gray-500 mt-1">Available facilities</p>
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="antiSeismic" name="antiSeismic" [disabled]="loading()" id="antiSeismic"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="antiSeismic" class="ml-2 block text-sm text-gray-700">Anti-Seismic</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="acSplit" name="acSplit" [disabled]="loading()" id="acSplit"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="acSplit" class="ml-2 block text-sm text-gray-700">Split AC</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="acCentral" name="acCentral" [disabled]="loading()" id="acCentral"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="acCentral" class="ml-2 block text-sm text-gray-700">Central AC</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="oilHeating" name="oilHeating" [disabled]="loading()" id="oilHeating"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="oilHeating" class="ml-2 block text-sm text-gray-700">Oil Heating</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="fireplace" name="fireplace" [disabled]="loading()" id="fireplace"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="fireplace" class="ml-2 block text-sm text-gray-700">Fireplace</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="americanKitchen" name="americanKitchen" [disabled]="loading()" id="americanKitchen"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="americanKitchen" class="ml-2 block text-sm text-gray-700">American Kitchen</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="fittedKitchen" name="fittedKitchen" [disabled]="loading()" id="fittedKitchen"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="fittedKitchen" class="ml-2 block text-sm text-gray-700">Fitted Kitchen</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="kitchenette" name="kitchenette" [disabled]="loading()" id="kitchenette"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="kitchenette" class="ml-2 block text-sm text-gray-700">Kitchenette</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="doubleGlazing" name="doubleGlazing" [disabled]="loading()" id="doubleGlazing"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="doubleGlazing" class="ml-2 block text-sm text-gray-700">Double Glazing</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="electricShutters" name="electricShutters" [disabled]="loading()" id="electricShutters"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="electricShutters" class="ml-2 block text-sm text-gray-700">Electric Shutters</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="concierge" name="concierge" [disabled]="loading()" id="concierge"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="concierge" class="ml-2 block text-sm text-gray-700">Concierge</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="videophone" name="videophone" [disabled]="loading()" id="videophone"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="videophone" class="ml-2 block text-sm text-gray-700">Videophone</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="isFurnished" name="isFurnished" [disabled]="loading()" id="isFurnished"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="isFurnished" class="ml-2 block text-sm text-gray-700">Furnished</label>
        </div>
      </div>
    </div>

    <!-- Condition & Parking Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-rose-500 to-rose-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Condition & Parking</h3>
          <p class="text-sm text-gray-500 mt-1">Property state and parking options</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">General Condition</label>
          <select [(ngModel)]="generalCondition" name="generalCondition" [disabled]="loading()"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300">
            <option [ngValue]="null">Select condition</option>
            <option value="excellent">Excellent</option>
            <option value="good">Good</option>
            <option value="fair">Fair</option>
            <option value="needs_work">Needs Work</option>
            <option value="renovation_required">Renovation Required</option>
          </select>
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Covered Parking</label>
          <input type="number" [(ngModel)]="parkingCovered" name="parkingCovered" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Outdoor Parking</label>
          <input type="number" [(ngModel)]="parkingOutdoor" name="parkingOutdoor" [disabled]="loading()" placeholder="0" min="0"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed transition-all duration-200 hover:border-gray-300" />
        </div>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-6 mt-6">
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="needsRenovation" name="needsRenovation" [disabled]="loading()" id="needsRenovation"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="needsRenovation" class="ml-2 block text-sm text-gray-700">Needs Renovation</label>
        </div>
        <div class="flex items-center">
          <input type="checkbox" [(ngModel)]="cellar" name="cellar" [disabled]="loading()" id="cellar"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
          <label for="cellar" class="ml-2 block text-sm text-gray-700">Cellar</label>
        </div>
      </div>
    </div>

    <!-- Pricing Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Pricing</h3>
          <p class="text-sm text-gray-500 mt-1">Set your property price</p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            💵 Price <span class="text-red-500">*</span>
          </label>
          <div class="relative">
            <input
              type="number"
              [(ngModel)]="price"
              name="price"
              [disabled]="loading()"
              placeholder="0"
              min="0"
              class="w-full px-4 py-3 pl-12 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 font-semibold text-lg"
            />
            <div class="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 font-semibold">$</div>
          </div>
        </div>

        <div class="group">
          <label class="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            🌎 Currency
          </label>
          <select
            [(ngModel)]="currency"
            name="currency"
            [disabled]="loading()"
            class="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 transition-all duration-200 hover:border-gray-300 text-gray-900 bg-white font-medium"
          >
            <option *ngFor="let curr of currencies()" [value]="curr.code">
              {{ curr.code }} - {{ curr.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Images Section -->
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 hover:shadow-md transition-all duration-300">
      <div class="flex items-center gap-4 mb-8 pb-6 border-b border-gray-100">
        <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-pink-500 to-pink-600 flex items-center justify-center shadow-lg">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
          </svg>
        </div>
        <div>
          <h3 class="text-xl font-bold text-gray-900">Property Images</h3>
          <p class="text-sm text-gray-500 mt-1">Upload photos to showcase your property</p>
        </div>
      </div>

      <!-- Upload Area -->
      <div class="mb-8">
        <label class="block text-sm font-semibold text-gray-700 mb-3">Upload Images</label>
        <div 
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          [class.border-blue-500]="isDragging()"
          [class.bg-blue-50]="isDragging()"
          [class.border-gray-300]="!isDragging()"
          class="relative border-2 border-dashed rounded-2xl p-8 sm:p-12 text-center cursor-pointer hover:border-blue-400 hover:bg-gradient-to-br hover:from-blue-50 hover:to-transparent transition-all duration-300 group">
          <input
            type="file"
            multiple
            accept="image/*"
            (change)="onFilesSelected($event)"
            [disabled]="loading()"
            class="hidden"
            #fileInput
          />
          <div (click)="!loading() && fileInput.click()" class="relative z-10">
            <div class="mx-auto w-12 h-12 sm:w-16 sm:h-16 mb-3 sm:mb-4 rounded-2xl bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-8l-3.172-3.172a4 4 0 00-5.656 0L28 20m0 0l-3.172-3.172a4 4 0 00-5.656 0l-10.172 10.172M21 15h.01M33 35H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <p class="text-gray-700 mb-1 sm:mb-2 font-medium text-sm sm:text-base">
              {{ isDragging() ? 'Drop images here' : 'Click to upload or drag and drop' }}
            </p>
            <p class="text-xs sm:text-sm text-gray-500">PNG, JPG up to 5MB each</p>
          </div>
        </div>
      </div>

      <!-- Uploaded Images Gallery -->
      <div *ngIf="uploadedImages().length > 0" class="space-y-4">
        <div class="flex items-center justify-between">
          <h4 class="text-sm font-semibold text-gray-900">Uploaded Images</h4>
          <span class="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-semibold">{{ uploadedImages().length }} {{ uploadedImages().length === 1 ? 'image' : 'images' }}</span>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
          <div *ngFor="let image of uploadedImages(); let i = index" class="group relative">
            <div class="relative aspect-square bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300">
              <img
                [src]="image.preview"
                [alt]="image.alt_text || 'Preview'"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <!-- Primary Badge -->
              <div *ngIf="image.is_primary" class="absolute top-3 left-3 bg-gradient-to-r from-green-500 to-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold shadow-lg flex items-center gap-1">
                <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                Primary
              </div>
            </div>

            <!-- Image Controls -->
            <div class="mt-3 space-y-2">
              <input
                type="text"
                [(ngModel)]="image.alt_text"
                (ngModelChange)="setAltText(i, $event)"
                name="altText_{{ i }}"
                [disabled]="loading()"
                placeholder="Add description..."
                class="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:text-gray-500 placeholder-gray-400 transition-all duration-200"
              />
              <div class="flex gap-2">
                <button
                  type="button"
                  *ngIf="!image.is_primary"
                  (click)="setPrimary(i)"
                  [disabled]="loading()"
                  class="flex-1 text-xs px-3 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm hover:shadow-md"
                >
                  Set Primary
                </button>
                <button
                  type="button"
                  (click)="removeImage(i)"
                  [disabled]="loading()"
                  class="flex-1 text-xs px-3 py-2 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg hover:from-red-600 hover:to-red-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium shadow-sm hover:shadow-md"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Submit Buttons -->
    <div class="flex flex-col sm:flex-row gap-4 pt-4">
      <button
        type="button"
        (click)="submitListing()"
        [disabled]="loading()"
        class="flex-1 bg-gradient-to-r from-immovea-navy to-blue-800 hover:from-blue-900 hover:to-blue-950 text-white px-8 py-4 rounded-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 font-semibold shadow-lg hover:shadow-xl hover:scale-[1.02] flex items-center justify-center gap-3 text-lg"
      >
        <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" *ngIf="!loading()">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
        <svg class="w-6 h-6 animate-spin" fill="none" viewBox="0 0 24 24" *ngIf="loading()">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <ng-container *ngIf="!loading() && isEditMode()">Update Listing</ng-container>
        <ng-container *ngIf="!loading() && !isEditMode()">Create Listing</ng-container>
        <ng-container *ngIf="loading() && isEditMode()">Updating...</ng-container>
        <ng-container *ngIf="loading() && !isEditMode()">Creating...</ng-container>
      </button>
      <button
        type="button"
        (click)="goBack()"
        [disabled]="loading()"
        class="flex-1 sm:flex-none bg-white hover:bg-gray-50 text-gray-700 px-8 py-4 rounded-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 font-semibold border-2 border-gray-200 hover:border-gray-300 flex items-center justify-center gap-2"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
        </svg>
        Cancel
      </button>
    </div>
  </form>
  </div>
</div>
